/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface EnrollmentScheduleControllerSearchTodayScheduleV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 시작일
 */
  centerId: string;

/**
 * 보호자 이름
 */
  gender?: 'MALE' | 'FEMALE';

/**
 * 담당 선생님
 */
  centerUserIds?: Array<string>;

/**
 * 보호자
 */
  guardianIds?: Array<string>;

/**
 * 치료 유형
 */
  ticketTypeIds?: Array<string>;

/**
 * 서비스
 */
  ticketIds?: Array<string>;

/**
 * 수납 상태
 */
  receiptStatus?: 'PENDING' | 'COMPLETED' | 'REFUND';
}

export function enrollmentScheduleControllerSearchTodayScheduleV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerSearchTodayScheduleV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerSearchTodayScheduleV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('centerId', params.centerId, {});
    rb.query('gender', params.gender, {});
    rb.query('centerUserIds', params.centerUserIds, {});
    rb.query('guardianIds', params.guardianIds, {});
    rb.query('ticketTypeIds', params.ticketTypeIds, {});
    rb.query('ticketIds', params.ticketIds, {});
    rb.query('receiptStatus', params.receiptStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto>;
    })
  );
}

enrollmentScheduleControllerSearchTodayScheduleV1.PATH = '/api/v1/enrollment-schedule/today-receipt';
